var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.356 5.943c.432-.298.95-.403 1.457-.298.508.104.946.408 1.233.852l5.001 7.783c.197.307.215.701.047 1.025a.966.966 0 01-.854.528H1.76a.959.959 0 01-.853-.528c-.17-.325-.15-.72.047-1.026l3.29-5.092c.015-.022.08-.116.096-.136.678-.868 1.899-1.007 2.731-.315l.789.65L9.845 6.46c.138-.204.311-.379.511-.517zM4.8 3.167c.803 0 1.454.671 1.454 1.5 0 .828-.65 1.5-1.454 1.5-.803 0-1.454-.672-1.454-1.5 0-.829.651-1.5 1.454-1.5z"
  }))));
}

export default SvgImageLandscape;